// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5e9d2","image":"_79718","content":"_254bb","info":"_56c6d","title":"_52e4d","button":"ec05e"};